import hcpApi from '../../api/Hcp';

import Pusher from '../../helpers/PusherManager';

export default {
  watch: {
    "route": function() {
      let self = this;
      self.onMounted();
    }
  },
  data() {
    return {
      hcp_pusher: null,
      welcome_accept: false
    }
  },
  methods: {
    onMounted() {
      let self = this;
      self.checkStatusOfHcpUser();
      self.initPusher();
    },
    checkStatusOfHcpUser() {
      let self = this;
      // check status only if viewing hcp view
      if(self.isHcpView) {
        hcpApi.getHcpUser().then(response => {
          if(response.data.steps.complete === false) {
            self.$router.push({
              name: 'HcpGettingStarted'
            });
          }
          if( response.data.scope.welcome_accept === false ) {
            self.welcome_accept = true;
          }
        });
      }
    },
    switchProgram() {
      let self = this;
      if(self.isHcpVerified === true) {
        hcpApi.switchProgram().then(response => {
          if(!response.data.error) {
            self.$toastr.success(response.data.message);
            self.$store.state.user.user_role.role_id = response.data.program;
            self.$EventBus.$emit('App::onProgramSwitch', response.data.program);
            self.$router.push({
              name: 'Dashboard'
            });
          }
        }).catch(error => {
          if(error.data.response) {
            self.$toastr.error(error.data.response.message);
          }
        });
      }
    },
    initPusher() {
      let self = this;
      if(_.has(self.$store.state.user, 'scope')) {
        let userId = self.$store.state.user.scope.user_id;
        self.hcp_pusher = Pusher.subscribe('hcp_' + userId);
        self.hcp_pusher.bind('verify', (data) => {
          if (data.verified === true) {
            self.$store.state.user.isHcpVerified = true;
            self.$toastr.success('Congratulations, your identity verification has been approved!');
          } else {
            self.$router.push({
              name: 'HcpGettingStarted'
            });
            self.$toastr.error('Sorry, but your identity verification has been rejected!');
            self.$store.state.user.isHcpVerified = false;
          }
        });
      }
    }
  },
  computed: {
    isHcpView() {
      let self = this;
      if(_.has(self.$store.state.user.user_role, 'role_id')) {
        return self.$store.state.user.user_role.role_id === 3;
      }
    },
    isHcpUser() {
      let self = this;
      if(_.has(self.$store.state.user, 'isHcp')) {
        return self.$store.state.user.isHcp === true;
      }
    },
    isHcpVerified() {
      let self = this;
      if(_.has(self.$store.state.user, 'isHcp')) {
        return self.$store.state.user.isHcpVerified === true;
      }
    },
    userId() {
      let self = this;
      if(_.has(self.$store.state.user, 'scope')) {
        return self.$store.state.user.scope.user_id;
      }
    }
  },
  mounted() {
    let self = this;
    Pusher.unsubscribe('hcp_' + self.userId);
    self.onMounted();
  }
}



// WEBPACK FOOTER //
// ./src/mixins/HCPMixin/index.js